import { HttpInterceptorFn } from '@angular/common/http';
import { getTimezoneOffsetNumber } from '@core/utils/get-timezone-offset-number';

export const timezoneInterceptor: HttpInterceptorFn = (request, next) => {
  return next(
    request.clone({
      setHeaders: {
        timeZone: getTimezoneOffsetNumber(),
      },
    })
  );
};
